import { Auth } from '@ax/auth';
import { getProviderPreferenceData } from '@ax/service';
import { useQuery } from '@tanstack/react-query';

export function useGetProviderPreferenceDataApi() {
  const query = useQuery({
    queryKey: ['providerPreferenceData'],
    queryFn: () => getProviderPreferenceData(),
    onError: (error: Error) => {
      console.log(error);
    },
    enabled: !!Auth.haveToken(),
    cacheTime: 0,
  });
  return query;
}
